<template>
  <div
    class="order-form"
  >
    <content-creator
      v-if="!orderId"
      :settings="getBlobContents('somnambulist-banner')"
      :permissions="contentCreatorPermissions"
      :is-visible="editContentCreator"
      :filestore="websitefilestore"
      allowed-widgets="carousel,vimeo-video"
      class="header-carousel"
      name="bannerBlob"
      @updateBlob="(payload) => saveBlob('somnambulist-banner', payload)"
    />
    <div
      v-if="!orderId"
      class="intro-step-container"
    >
      <div class="container intro-step">
        <content-creator
          :settings="getBlobContents('somnambulist-intro')"
          :permissions="contentCreatorPermissions"
          :is-visible="editContentCreator"
          :filestore="websitefilestore"
          allowed-widgets="grid, link-list, advanced-wysiwyg-editor, wysiwyg-editor, carousel, content-list, content-grid, vimeo-video"
          name="introBlob"
          @updateBlob="(payload) => saveBlob('somnambulist-intro', payload)"
        />
      </div>
    </div>
    <template v-if="hasData">
      <template v-if="showFull">
        <step
          :step-number="1"
          header-lang-string-id="orderTypeStep"
          step-component="order-type-step"
        />
        <transition name="fade">
          <step
            v-if="getCurrentStep > 1"
            :step-number="2"
            header-lang-string-id="frequencyStep"
            step-component="frequency-step"
          />
        </transition>
        <transition name="fade">
          <step
            v-if="getCurrentStep > 2"
            :step-number="3"
            header-lang-string-id="quantityStep"
            step-component="quantity-step"
          />
        </transition>
      </template>
      <transition name="fade">
        <step
          v-if="getCurrentStep > 3 && isCustomOrder"
          :step-number="4"
          header-lang-string-id="customStep"
          step-component="custom-step"
          @modalToggled="productModalActive = !productModalActive"
        />
      </transition>
    </template>
    <div
      v-else
      class="no-clubs"
    >
      No clubs were found. This could either be because there are no clubs setup or that they failed to load.
    </div>
    <stepper
      :lowerzindex="productModalActive"
      @completed="setCompleted()"
      @changed="$emit('changed')"
    />
    <AModal
      v-if="groupExistsObject"
      v-model="groupExistsModalVisible"
      disable-portaling
    >
      <div class="already-exists">
        <div class="icon">
          <MembershipExistsIcon />
        </div>
        <h3 class="title">
          <template v-if="groupExistsObject.multiple">
            You have multiple active memberships of this type.
          </template>
          <template v-else>
            You have an active membership of this type.
          </template>
        </h3>
        <p class="lead">
          <template v-if="groupExistsObject.multiple">
            You can <a
              href="#"
              @click="groupExistsModalVisible = false"
            >continue</a> with your order, however a new one will be created.
            Alternatively, you could <generic-link :href="`/user/${userId}/membership`">
              visit your member portal
            </generic-link> and update your current memberships.
          </template>
          <template v-else>
            You can <a
              href="#"
              @click="groupExistsModalVisible = false"
            >continue</a> with your order, however a new one will be created.
            Alternatively, you could <generic-link :href="`/wine-club/edit/${groupExistsObject.orderId}`">
              edit
            </generic-link> your existing membership.
          </template>
        </p>
      </div>
    </AModal>
    <a-modal
      v-if="modalVisible"
      v-model="modalVisible"
      disable-portaling
      :enable-close="false"
    >
      <div class="login-account-section">
        <h3 class="login-account-lead">
          Log in or Create a New Account to continue<br>
          your Wine Club Registration.<br><br>
          <a
            href="#"
            @click.prevent="changeOrder"
          >
            Click here
          </a>
          to change your selection<br>
        </h3>
      </div>
      <login-subform
        :show-create-account="true"
        @loginInProgress="loginInProgress"
      />
    </a-modal>
  </div>
</template>

<script>
import Order from './Order'
import Step from './Step'
import Stepper from './Stepper'
import VueScrollTo from 'vue-scrollto'
import ContentCreator from 'src/app/content-creator-mixin'
import MembershipExistsIcon from '../../svgs/MembershipExistsIcon'

export default {
  name: 'order',
  components: {
    Step,
    Stepper,
    MembershipExistsIcon
  },
  mixins: [
    Order,
    ContentCreator
  ],
  data() {
    return {
      groupExistsModalVisible: false,
      groupExistsObject: null,
      productModalActive: false
    }
  },
  computed: {
    showFull() {
      return this.$store.state.somnambulistui.editMode === 'edit' || !this.isCustomOrder
    },
    selectedQuantity() {
      return this.$store.getters['somnambulistui/getSelectedQuantityObject']
    },
    userId() {
      return this.$store.getters['user/userid']
    },
    currentGroups() {
      return this.$store.state.somnambulistui.currentGroups
    },
    hasData() {
      return this.$store.state.somnambulistui.clubs && this.$store.state.somnambulistui.clubs.length
    },
    modalVisible: {
      get: function() {
        return this.$store.state.somnambulistui.orderCompleted && (
          !this.$store.getters['user/isLoggedIn'] ||
          this.$store.getters['somnambulistui/initUid'] === 0
        )
      },
      set: function() {
        // Do Nothing. The only way to hide the modal is to be logged in.
      }
    }
  },
  watch: {
    selectedQuantity(val) {
      if (val) {
        this.checkGroupExists()
      }
    },
    currentGroups(val) {
      if (val && val.length) {
        this.checkGroupExists()
      }
    }
  },
  created() {
    if (typeof localStorage !== 'undefined') {
      const selectedOrder = JSON.parse(localStorage.getItem('somnambulistSelectedOrder'))
      if (selectedOrder) {
        this.$store.commit('somnambulistui/SET_SELECTED_ORDER_TYPE', selectedOrder.selectedOrderType)
        this.$store.commit('somnambulistui/SET_SELECTED_QUANTITY', selectedOrder.selectedQuantity)
        this.$store.commit('somnambulistui/SET_SELECTED_FREQUENCY', selectedOrder.selectedFrequency)
        this.$store.commit('somnambulistui/SET_SELECTED_PRODUCTS', selectedOrder.selectedProducts)
        this.$store.commit('somnambulistui/SET_SUBSTITUTE_PRODUCTS', selectedOrder.substituteProducts)
        this.$store.commit('somnambulistui/SET_ORDER_COMPLETED', selectedOrder.orderCompleted)
        this.$store.dispatch('somnambulistui/updateSelectedOrderOtherClub')
        if (this.$store.getters['user/isLoggedIn']) {
          localStorage.removeItem('somnambulistSelectedOrder')
        }
      }
    }
  },
  mounted() {
    if (typeof document !== 'undefined') {
      if (this.$store.state.somnambulistui.updatingOrder) {
        VueScrollTo.scrollTo(document.getElementById('somnambulist-step-1'))
      }
      else if (this.$store.state.somnambulistui.scrollTop) {
        VueScrollTo.scrollTo(document.querySelector('body'))
        this.$store.commit('somnambulistui/RESET_SCROLL')
      }
    }

    if (this.$store.getters['blob/isHeader']('somnambulist-banner')) {
      this.$store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
    }
  },
  methods: {
    changeOrder() {
      if (!this.orderLocked) {
        if (typeof localStorage !== 'undefined') {
          localStorage.removeItem('somnambulistSelectedOrder')
        }

        this.$store.commit('somnambulistui/SET_DIRTY_FLAG', { key: 'order', value: true })
        this.$store.commit('somnambulistui/SET_UPDATING_ORDER', true)
        this.SET_ORDER_COMPLETED(false)
      }
    },
    loginInProgress() {
      this.$eventHub.$emit('somnambulistLoginInProgress')
    },
    setCompleted() {
      this.SET_ORDER_COMPLETED(true)
      this.$store.dispatch('somnambulistui/persistOrderCompleted')
    },
    checkGroupExists() {
      if (this.selectedQuantity && this.selectedQuantity.nid != null) {
        if (this.currentGroups[this.selectedQuantity.nid]) {
          this.groupExistsModalVisible = true
          this.groupExistsObject = this.currentGroups[this.selectedQuantity.nid]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.login-account-section {
  text-align: center;
  /deep/h3 {
    font-size: 1.1em;
    color: var(--main-text-heading-color);
  }
}

.already-exists {
  text-align: center;
  .icon {
    opacity: 0.4;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    svg {
      width: 100%;
      height: 100%;
    }
  }
}

.order-form {
  .fade-enter-active .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .cancel-button {
    margin-top: 2em;
  }
}

.intro-step-container {
  background-color: var(--main-section-alternate-background-color);
  /deep/.container {
    .wysiwyg-content {
      padding: 3em 0em;
    }
  }
}

.no-clubs {
  padding: 4em 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

</style>

<style lang="scss">
.order-form {
  section {
    .container {
      // z-index: 2;
      position: relative;
    }
  }
}
</style>
